module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "k_e"
  }, [_c('table', {
    staticClass: "k_e_t",
    attrs: {
      "colspan": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w50"
  }, [_vm._v("行号")]), _vm._v(" "), _c('th', {
    staticClass: "w150"
  }, [_vm._v("操作")]), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return _c('th', {
      key: field.id,
      attrs: {
        "draggable": "",
        "data-field": field.name,
        "data-key": field.id
      },
      on: {
        "dragstart": _vm.handleDragstart,
        "dragenter": _vm.handleDragenter,
        "dragleave": _vm.handleDragleave,
        "dragend": _vm.handleDrop
      }
    }, [_vm._v("\n          " + _vm._s(field.label) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataList), function(row, rowIndex) {
    return _c('tr', {
      key: row[_vm.config.primaryKey],
      attrs: {
        "data-key": row[_vm.config.primaryKey]
      }
    }, [_c('th', {
      staticClass: "row-no"
    }, [_vm._v(_vm._s(rowIndex + 1))]), _vm._v(" "), _c('th', [_c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addRow(row, rowIndex, $event)
        }
      }
    }, [_vm._v("新增一行")]), _vm._v(" "), _c('a', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteRow(row, rowIndex, $event)
        }
      }
    }, [_vm._v("删除此行")])]), _vm._v(" "), _vm._l((_vm.fields), function(cell, cellIndex) {
      return _c('td', {
        key: cell.id,
        attrs: {
          "data-key": cell.id
        }
      }, [_c('k-field', {
        attrs: {
          "data-key": cell.id,
          "row-index": rowIndex,
          "cell-index": cellIndex,
          "table": _vm.table[cell.name],
          "type": cell.type,
          "value": row[cell.name],
          "len": 0,
          "list-slots": _vm.list[cell.name]
        },
        on: {
          "update:value": function($event) {
            _vm.$set(row, cell.name, $event)
          },
          "on-choose": _vm.onChoose
        }
      })], 1)
    })], 2)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-874fa1f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KEditable.vue
// module id = 120
// module chunks = 1